export const Layout = ({ children }: { children?: React.ReactNode }) => (
	<div className="grid md:grid-cols-2 min-h-screen bg-background">
		<div className="p-6 flex items-center justify-center bg-background-upper/40">
			{children}
		</div>
		<div
			className="relative p-6 flex items-center justify-center bg-[#14140F] text-paper overflow-hidden"
			style={{
				backgroundImage: [
					'radial-gradient(circle at 22% 28%, rgba(250,247,238,0.06), transparent 45%)',
					'radial-gradient(circle at 80% 72%, rgba(155,181,252,0.10), transparent 45%)',
				].join(', '),
			}}
		>
			{/* hex-grid texture, very faint */}
			<div
				aria-hidden
				className="absolute inset-0 opacity-[0.05] pointer-events-none"
				style={{
					backgroundImage:
						"url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='56' height='64' viewBox='0 0 56 64'><polygon points='28,2 54,16 54,48 28,62 2,48 2,16' fill='none' stroke='%23faf7ee' stroke-width='1'/></svg>\")",
					backgroundSize: '56px 64px',
				}}
			/>

			<div className="relative w-full max-w-md">
				<div className="flex items-baseline justify-center gap-2">
					<span className="font-display italic text-6xl tracking-tight leading-none">roj</span>
					<span aria-hidden className="size-1.5 rounded-full bg-paper translate-y-[-6px]" />
				</div>
				<div className="mt-3 text-center font-mono text-[11px] uppercase tracking-[0.32em] text-paper-deep/80">
					Agent Platform · Cloud
				</div>
				<p className="mt-10 text-center text-paper-deep/85 leading-relaxed font-light">
					A swarm of agents, sandboxed and orchestrated.<br />
					<span className="text-paper-deep/55">Run, observe, iterate.</span>
				</p>
			</div>
		</div>
	</div>
)
